import { EmailArchive } from './email';
import { DateTime } from 'luxon';

export namespace EmailParsers {
  export class EmailArchiveJson {
    id!: string;
    sender!: string;
    receiver!: string;
    emailTemplateName!: string;
    displayName!: string;
    subject!: string;
    body!: string;
    sentAt!: string;
  }

  export function toEmailArchive(json: EmailArchiveJson): EmailArchive {
    return {
      id: json.id,
      sender: json.sender,
      receiver: json.receiver,
      emailTemplateName: json.emailTemplateName,
      displayName: json.displayName,
      subject: json.subject,
      body: json.body,
      sentAt: DateTime.fromISO(json.sentAt, { setZone: true }),
    };
  }
}
